import React, { useRef, useState } from 'react';
import LeaseDetails from './LeaseDetails';

import { useDispatch } from 'react-redux';
import { deleteLease, toggleLeaseStatus } from '../../redux/actions/LeaseActions';
import { toast } from 'react-toastify';


const LeaseList = ({
  leases = [],
  pagination,
  page,
  setPage,
  onFilter,
  loading
}) => {
  const [search, setSearch] = useState('');
  const debounceTimeout = useRef();

  const [viewModal, setViewModal] = useState(false);
  const [selectedLease, setSelectedLease] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
const [leaseToDelete, setLeaseToDelete] = useState(null);
const [disabledLeaseId, setDisabledLeaseId] = useState(null);


  const dispatch = useDispatch();


  // 🔹 local state for UI-only delete
  // const [localLeases, setLocalLeases] = useState(leases);

  // sync local leases when API data changes
  // React.useEffect(() => {
  //   setLocalLeases(leases);
  // }, [leases]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);

    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    debounceTimeout.current = setTimeout(() => {
      const filter = {};
      if (value) filter.q = value;
      onFilter(filter);
    }, 350);
  };

  const handleView = (lease) => {
    setSelectedLease(lease);
    setViewModal(true);
  };

  const handleCloseModal = () => {
    setViewModal(false);
    setSelectedLease(null);
  };

  const handleDeleteClick = (lease) => {
    setLeaseToDelete(lease);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!leaseToDelete) return;
  
    const res = await dispatch(deleteLease(leaseToDelete.id));
  
    if (res.meta.requestStatus === 'fulfilled') {
      setShowDeleteModal(false);
      setLeaseToDelete(null);
    } else {
      const msg = res.payload?.message;
      if (msg === "Active lease cannot be deleted. Please deactivate or end the lease first.") {
        setShowDeleteModal(false);
        setLeaseToDelete(null);
      }
    }
  };

  const handleToggleStatus = async (lease) => {

    const activate = lease.status !== "ACTIVE";
    setDisabledLeaseId(lease.id);
    try{
    const res = await dispatch(
      toggleLeaseStatus({ id: lease.id, activate })
    );
  
    if (res.meta.requestStatus === 'fulfilled') {
      toast.success(`Lease ${activate ? 'activated' : 'deactivated'} successfully`);
      setDisabledLeaseId(null);
      onFilter({});
    }}catch(err){
      setDisabledLeaseId(null);
    }
  };
  
  

  return (
    <div className="container py-4">
      {/* FILTERS */}
      <div className="row mb-3 g-2">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search by lease, tenant, landlord, property, city..."
            value={search}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      {/* TABLE */}
      <div className="row g-4">
        <table className="table table-striped table-hover align-middle">
          <thead className="table-primary">
            <tr>
              <th>Lease Name</th>
              <th>Property</th>
              <th>Landlord</th>
              <th>Tenant</th>
              <th>Province</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan="6" className="text-center">
                  Loading...
                </td>
              </tr>
            )}

            {/* {!loading && localLeases.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center text-muted">
                  No leases found
                </td>
              </tr>
            )} */}

            {!loading &&
              leases.map((lease) => (
                <tr key={lease.id}>
                  <td>
                    <strong>{lease.lease_name || '-'}</strong>
                  </td>

                  <td>{lease.property?.property_name || '-'}</td>

                  <td>
                    {lease.landlord
                      ? `${lease.landlord.first_name} ${lease.landlord.last_name}`
                      : '-'}
                  </td>

                  <td>
                    {lease.tenant
                      ? `${lease.tenant.first_name} ${lease.tenant.last_name}`
                      : '-'}
                  </td>

                  <td>{lease.property?.province?.name || '-'}</td>

                  <td>
                    <div className="d-flex gap-2">
                    <button
  className={`btn btn-sm ${
    lease.status === "ACTIVE" ? "btn-warning" : "btn-success"
  }`}
  onClick={() => handleToggleStatus(lease)}
  disabled={disabledLeaseId === lease.id}
>
  {lease.status === "ACTIVE" ? (
    <>
      <i className="bi bi-x-circle"></i> Deactivate
    </>
  ) : (
    <>
      <i className="bi bi-check-circle"></i> Activate
    </>
  )}
</button>
                      <button
                        className="btn btn-sm btn-info text-white"
                        onClick={() => handleView(lease)}
                      >
                        <i className="bi bi-eye"></i> View
                      </button>

                      {/* <button
                        className="btn btn-sm btn-danger text-white"
                        onClick={() => handleDelete(lease.id)}
                      > */}
                      <button
  className="btn btn-sm btn-danger text-white"
  onClick={() => handleDeleteClick(lease)}
>

                        <i className="bi bi-trash"></i> Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* VIEW MODAL */}
      {viewModal && selectedLease && (
        <LeaseDetails
          selectedLease={selectedLease}
          handleCloseModal={handleCloseModal}
        />
      )}

{showDeleteModal && leaseToDelete && (
  <>
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">Delete Lease</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setShowDeleteModal(false)}
            />
          </div>

          <div className="modal-body">
            <p>
              Are you sure you want to delete
              <strong> {leaseToDelete.lease_name}</strong>?
            </p>
            <p className="text-muted mb-0">
              This lease will be deleted permanently.
            </p>
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger"
              onClick={confirmDelete}
            >
              Delete
            </button>
          </div>

        </div>
      </div>
    </div>

    {/* Backdrop */}
    {/* <div className="modal-backdrop fade show" /> */}
  </>
)}
  <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>


      {/* PAGINATION */}
      {pagination?.totalPages > 1 && (
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <span className="align-self-center">
            Page {page} of {pagination.totalPages}
          </span>

          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === pagination.totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
       
    </div>
  );
};

export default LeaseList;
